<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            {{ symLocation.location_code }}
        </template>

        <slot>
            <div class="card mb-2">
                <div class="card-header pr-1 d-flex align-items-center">
                    <span class="btnlike mr-auto">
                        <h4 class="mb-0">Details</h4>
                    </span>
                </div>

                <div class="card-body py-1">
                    <section class="item-details-section">
                        <div>
                            <span  class="text-semibold">State Code: </span>
                            <span>{{ symLocation.state_code || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">County Code: </span>
                            <span>{{ symLocation.county_code || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">City Code: </span>
                            <span>{{ symLocation.city_code || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Municipality Code: </span>
                            <span>{{ symLocation.municipality_code || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Transit District Code: </span>
                            <span>{{ symLocation.transit_district_code || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">School Code: </span>
                            <span>{{ symLocation.school_code || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Is Active: </span>
                            <span>{{ symLocation.is_active ? 'Yes' : 'No' }}</span>
                        </div>
                    </section>
                </div>
            </div>
        </slot>
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'

export default {
    components: {Sidebar},
    props: ['symLocation'],
}
</script>
